import ControlArea from "components/Layout/ControlArea";
import { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllPageSections,
  getAllSocialTypes,
  getAllSocials,
} from "store/actions";
import Icon from "assets/svgs/socials.svg";
import Table from "./Table";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";

const SocialTypes = () => {
  const dispatch = useDispatch();

  const { socialTypes, loading, error } = useSelector(
    (state) => state.socialTypes
  );
  const { formatMessage, locale } = useIntl();

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  useEffect(() => {
    dispatch(getAllSocialTypes());
    // dispatch(getAllPageSections("socialTypes"));
  }, [dispatch]);

  return (
    <div className="socialTypes-wrap__">
      <ControlArea
        btnTxt={<FormattedMessage id={"addSocial"} />}
        cardTxt={<FormattedMessage id={"socialTypes"} />}
        icon={Icon}
        url="/socialTypes/addSocial"
      />
      <Table data={socialTypes} loading={loading} />
    </div>
  );
};

export default SocialTypes;
